import { FC } from 'react';
import Box from '@mui/material/Box';
import { SkeletonBar } from '../../../reusable-components/data-table/TableSkeleton';
import './messagingSkeleton.scss';

const NAME_WIDTHS = ['62%', '48%', '70%', '55%'];

export const EventChatsSkeleton: FC<{ events?: number }> = ({ events = 8 }) => (
  <Box className="messagingSkeleton" role="status" aria-label="Loading chats">
    {Array.from({ length: events }, (_, eventIndex) => (
      <Box key={eventIndex} className="messagingSkeleton__event">
        <Box className="messagingSkeleton__eventHeader">
          <SkeletonBar width={48} height={48} radius={5} />
          <Box className="messagingSkeleton__eventInfo">
            <SkeletonBar width={NAME_WIDTHS[eventIndex % NAME_WIDTHS.length]} height={18} />
            <Box className="messagingSkeleton__pills">
              <SkeletonBar width={84} height={24} radius={99} />
              <SkeletonBar width={58} height={24} radius={99} />
            </Box>
          </Box>
          <SkeletonBar width={16} height={16} radius={4} />
        </Box>
      </Box>
    ))}
  </Box>
);
